import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { animeList } from '@/mocks/anime';
import AnimeDetailComponent from './components/AnimeDetail';
import SimilarAnime from './components/SimilarAnime';
import CommentsSection from './components/CommentsSection';
import PlayCTA from './components/PlayCTA';

export default function Anime() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();

  const anime = animeList.find((a) => a.id === Number(id) || a.slug === id);

  useEffect(() => {
    if (anime) {
      document.title = `${anime.title}-在线观看-樱花动漫网`;
    } else {
      document.title = '动漫详情-樱花动漫网';
    }
  }, [anime]);

  if (!anime) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen flex items-center justify-center bg-background-50">
          <div className="text-center">
            <i className="ri-emotion-sad-line text-5xl text-foreground-300 mb-4 block"></i>
            <p className="text-foreground-600 text-lg mb-4">{t('暂无数据')}</p>
            <a
              href="/"
              className="inline-flex items-center gap-2 bg-primary-500 text-white px-6 py-2.5 rounded-full text-sm hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              {t('返回首页')}
            </a>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <SchemaOrg
        type="Article"
        data={{
          headline: `${anime.title} - 樱花动漫在线观看`,
          description: anime.description,
          image: anime.cover,
          datePublished: `${anime.year}-01-01`,
          author: {
            '@type': 'Organization',
            name: '樱花动漫网',
          },
          publisher: {
            '@type': 'Organization',
            name: '樱花动漫网',
          },
          mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': `http://kktyvqy.cn/article/${anime.slug}`,
          },
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: t('首页'), item: 'http://kktyvqy.cn/' },
            { '@type': 'ListItem', position: 2, name: t('分类'), item: `http://kktyvqy.cn/category/${anime.categorySlug}` },
            { '@type': 'ListItem', position: 3, name: anime.category },
            { '@type': 'ListItem', position: 4, name: anime.title },
          ],
        }}
      />

      <Navbar />

      <main>
        <Breadcrumb
          items={[
            { label: t('分类'), to: '/category/action' },
            { label: anime.category, to: `/category/${anime.categorySlug}` },
            { label: anime.title },
          ]}
        />
        <AnimeDetailComponent anime={anime} />
        <SimilarAnime currentAnimeId={anime.id} />
        <CommentsSection animeId={anime.id} />
        <PlayCTA />
      </main>

      <Footer />
    </>
  );
}
